import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

var Sizes;
(function(Sizes) {
    Sizes[Sizes['small'] = 16] = 'small';
    Sizes[Sizes['medium'] = 24] = 'medium';
    Sizes[Sizes['large'] = 32] = 'large';
})(Sizes || (Sizes = {}));
var Colors;
(function(Colors) {
    Colors["gold"] = "gold";
    Colors["black"] = "black";
})(Colors || (Colors = {}));
const Star = ({ className , fill , color =Colors.gold , size  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('store-rating-star', {
            'store-rating-star--empty': fill < 0.5,
            'store-rating-star--half': fill === 0.5,
            'store-rating-star--full': fill > 0.5,
            'store-rating-star__size--large': size === Sizes.large,
            'store-rating-star__size--medium': size === Sizes.medium,
            'store-rating-star__size--small': size === Sizes.small
        }, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('store-rating-star__foreground', {
            'store-rating-star__foreground--default-color': color === Colors.gold,
            'store-rating-star__foreground--black': color === Colors.black
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-rating-star__foreground-container"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "star",
        width: size,
        height: size
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "store-rating-star__background"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "star",
        width: size,
        height: size
    })))
;

export { Colors, Sizes, Star, Star as default };
//# sourceMappingURL=Star.js.map
